import React from 'react';
import { useTranslation } from 'react-i18next';
import BzmIcon from 'components/icons/BzmIcon';

type MockServiceIconProps = {
  size: number;
  type: 'SV' | 'TRANSACTIONAL' | any;
  className?: string;
};

/**
 * Virtual Service icon based on type.
 * @param props
 * @constructor
 */
const MockServiceIcon = (props: MockServiceIconProps) => {
  const { t } = useTranslation('common');
  const svIcon = (
    <BzmIcon
      title={t('mockServiceTypes.sv')}
      className={props.className}
      variant="icon-bzm-type-sv"
      size={props.size}
      color="#23475f"
    ></BzmIcon>
  );
  const httpService = (
    <BzmIcon title={'HTTP Virtual Service'} className={props.className} variant={'icon-bzm-http'} size={props.size} />
  );

  const messagingIcon = (
    <BzmIcon
      title={'Messaging Virtual Service'}
      className={props.className}
      variant="icon-bzm-stacked-email"
      size={props.size}
    />
  );

  switch (props.type) {
    case 'SV':
      return svIcon;
    case 'TRANSACTIONAL':
      return httpService;
    case 'MESSAGING':
      return messagingIcon;
  }

  return props.type === 'SV' ? svIcon : httpService;
};

export default MockServiceIcon;
